import { logger } from "@mwt/web-js-telemetry";

import {
  EHR_SERVICE_DOMAIN,
  EHR_SERVICE_PATH,
  ALLOWED_EHR_SERVICE_DOMAINS,
} from "../../../environments/environment";

export function convertToHttpsHost(input: string) {
  // Remove any preceeding `protocol://` strings and add `https://`
  return "https://" + input.replace(/^(.*?)(:|)\/\//, "");
}

/**
 * A function to validate the passed endpoint
 * and return a valid endpoint href with appropriate API `path` in it
 * @param endpoint any string that can be a `host` of a URL
 * @returns Validated endpoint href
 */
export function getValidatedEndpoint(
  endpoint: string = EHR_SERVICE_DOMAIN
): string {
  let endpointUrl: URL;

  try {
    endpointUrl = new URL(convertToHttpsHost(endpoint));
    if (!ALLOWED_EHR_SERVICE_DOMAINS.includes(endpointUrl.host)) {
      throw new Error(`invalid endpoint passed - ${endpoint}`);
    }
  } catch (error: any) {
    logger.debug(
      "[getValidatedEndpoint] - endpoint passed is not a URL - ",
      error
    );
    endpointUrl = new URL(convertToHttpsHost(EHR_SERVICE_DOMAIN));
  }
  endpointUrl.pathname = EHR_SERVICE_PATH;
  return endpointUrl.href;
}
